import base from './base'

const postVideoUpload = (videoParams) => {
  return base.post('/video_uploads/', videoParams).then(resp => resp.data)
}

export default {
  postVideoUpload: postVideoUpload,
}
